import http from '@/utils/http';
import { IDENTITY_KEY_NAME } from '@/constants';
import { getIdentity } from '@/utils/detectDevice';

const list = (id, attempt) => http.apiGet(`/report/${getIdentity(IDENTITY_KEY_NAME.UID)}/${id}/${attempt}`);

export default {
  list,
};
